import React from 'react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { gallery } from '../data/site';
export function Gallery() {
  return <section id="galeria" className="bg-white py-20 lg:py-28" data-id="element-163" data-mp="34esxbjbu8gu4">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-164" data-mp="3iawlow015uyo">
        <SectionHeading title="De potrero a comunidad" description="El avance real del proyecto, etapa por etapa." data-id="element-165" data-mp="3ddeeba1nvnss" />

        <div className="mt-14 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-166" data-mp="2po3jsaawmpn3">
          {gallery.map((item, index) => <Reveal key={item.title} delay={index * 0.04} data-id="element-167" data-mp="2kme7krby45xf" data-mpi={index}>
              <a href="#contacto" className="group relative block overflow-hidden rounded-sm" aria-label={`${item.title} — solicitar más información`} data-id="element-168" data-mp="2zef06wbryrav">
                <img src={item.src} alt={item.title} className="aspect-[4/3] w-full object-cover transition-transform duration-300 ease-smooth group-hover:scale-[1.06]" data-id="element-169" data-mp="26vrhtoo5xqdh" />
                <span className="absolute inset-0 bg-gold/0 transition-colors duration-200 ease-smooth group-hover:bg-gold/55" data-id="element-170" data-mp="wbnweyzsmalw" />
                <span className="absolute inset-x-0 bottom-0 p-5" data-id="element-171" data-mp="11249ghzpbu7q">
                  <span className="block font-display text-lg text-white drop-shadow" data-id="element-172" data-mp="153y86kqc6o59">
                    {item.title}
                  </span>
                  <span className="block text-[11px] uppercase tracking-[0.14em] text-white/85" data-id="element-173" data-mp="8eqkb628w2y6">
                    {item.caption}
                  </span>
                </span>
                <span className="absolute inset-0 grid place-items-center text-[12px] font-semibold uppercase tracking-[0.2em] text-white opacity-0 transition-opacity duration-200 ease-smooth group-hover:opacity-100" data-id="element-174" data-mp="hdvi2a5zfs9a">
                  Ver más
                </span>
              </a>
            </Reveal>)}
        </div>
      </div>
    </section>;
}